import { getAllSites, createOrUpdateSite, deleteSite } from "@/api";

export default {
  namespaced: true,
  state: {
    sites: [],
  },
  mutations: {
    SET_SITES(state, sites) {
      state.sites = sites;
    },
  },
  actions: {
    async fetchSites({ commit }) {
      const sites = await getAllSites(); // Assuming getOrganizations fetches sites
      commit("SET_SITES", sites);
    },
    async addOrUpdateSite({ dispatch }, site) {
      await createOrUpdateSite(site); // Assuming createOrUpdateOrganization handles sites
      dispatch("fetchSites");
    },
    checkNameExists({ state }, name) {
      return state.sites.some((site) => site.name === name);
    },
    async deleteSite({ dispatch }, siteId) {
      await deleteSite(siteId);
      dispatch("fetchSites");
    },
    replaceByIndex(index, newItem) {
      this.sites.splice(index, 1, newItem);
    },
    append(newItem) {
      this.sites.push(newItem);
    },
    updateSite(item) {
      const index = this.sites.findIndex((site) => site.id === item.id);
      if (index !== -1) {
        this.replaceByIndex(index, item);
      } else {
        this.append(item);
      }
    },
    getSiteById(id) {
      return this.sites.find((site) => site.id === id);
    },
  },
  getters: {
    sites: (state) => state.sites,
  },
};
